<template>
	<div class="content">
		<div class="backgo" @click="back()"><img src="../../assets/img/back.png" alt=""><div>返回</div></div>
		<div class="cont_title">添加试题</div>
		<div class="top">
			<el-form  ref="form" style="width: 100%;" :model="form" label-width="100px">
				<el-form-item label="试题类型：" prop="question_type">
				  <el-radio-group v-model="form.question_type" :disabled="jin">
				  	<el-radio v-for="item in sel" :key="item.value" :label="item.value">{{item.label}}
				  	</el-radio>
				  </el-radio-group>
				</el-form-item>
				<div v-if="form.question_type ==1">
					<el-form-item label="试题标题：" prop="question_title">
					  <el-input style="width: 720px;" v-model="form.question_title" placeholder="请输入" type="text"/>
					</el-form-item>
					<el-form-item label="所属课程：" prop="kecheng_id">
					  <el-select  style="width: 720px;" v-model="form.kecheng_id" placeholder="请选择">
						 <el-option
						   v-for="item in selist"
						   :key="item.id"
						   :label="item.kecheng_name"
						   :value="item.id">
						 </el-option>
					  </el-select>
					</el-form-item>	
					<el-form-item label="选项设置：" prop="question">
					  <div class="box">
						<div class="box_item" v-for="(item,index) in panduan" :key="index">
							<img class="ckas" v-if="item.is_yes == 1" src="../../assets/img/ok.png" >
							<img class="ckas" v-else src="../../assets/img/nook.png" @click="pandaunsel(index)">
							<el-input style="width: 70px;margin:0 15px;" v-model="item.option_sn"  type="text"/>
							<el-input v-model="item.option_title"  type="text"/>
							<img class="del" src="../../assets/img/del.png" alt="" @click="del(index)">
						</div>
					  </div>
					</el-form-item>	
					<el-form-item >
					  <div class="zujuan_btn" @click="addti()">
					  	<img src="../../assets/img/tea2.png" alt="">
					  	<div>添加选项</div>
					  </div>
					</el-form-item>	
				</div>
				<div v-if="form.question_type ==2">
					<el-form-item label="试题标题：" prop="question_title">
					  <el-input style="width: 720px;" v-model="form.question_title" placeholder="请输入" type="text"/>
					</el-form-item>
					<el-form-item label="所属课程：" prop="kecheng_id">
					  <el-select  style="width: 720px;" v-model="form.kecheng_id" placeholder="请选择">
						 <el-option
						   v-for="item in selist"
						   :key="item.id"
						   :label="item.kecheng_name"
						   :value="item.id">
						 </el-option>
					  </el-select>
					</el-form-item>	
					<el-form-item label="选项设置：" prop="question">
					  <div class="box">
						<div class="box_item" v-for="(item,index) in panduan" :key="index">
							<img class="ckas" v-if="item.is_yes == 1" src="../../assets/img/ok.png"  @click="duosel(index)">
							<img class="ckas" v-else src="../../assets/img/nook.png" @click="duosel(index)">
							<el-input style="width: 70px;margin:0 15px;" v-model="item.option_sn"  type="text"/>
							<el-input v-model="item.option_title"  type="text"/>
							<img class="del" src="../../assets/img/del.png" alt="" @click="del(index)">
						</div>
					  </div>
					</el-form-item>	
					<el-form-item >
					  <div class="zujuan_btn" @click="addti()">
					  	<img src="../../assets/img/tea2.png" alt="">
					  	<div>添加选项</div>
					  </div>
					</el-form-item>	
				</div>
				<div v-if="form.question_type ==3">
					<el-form-item label="试题标题：" prop="question_title">
					  <el-input style="width: 720px;" v-model="form.question_title" placeholder="请输入" type="text"/>
					</el-form-item>
					<el-form-item label="所属课程：" prop="kecheng_id">
					  <el-select  style="width: 720px;" v-model="form.kecheng_id" placeholder="请选择">
						 <el-option
						   v-for="item in selist"
						   :key="item.id"
						   :label="item.kecheng_name"
						   :value="item.id">
						 </el-option>
					  </el-select>
					</el-form-item>	
					<el-form-item label="选项设置：" prop="question">
					  <div class="box">
						<div class="box_item" v-for="(item,index) in panduan" :key="index">
							<img class="ckas" v-if="item.is_yes == 1" src="../../assets/img/ok.png" >
							<img class="ckas" v-else src="../../assets/img/nook.png" @click="pandaunsel(index)">
							<el-input style="width: 70px;margin:0 15px;" v-model="item.option_sn"  type="text"/>
							<el-input v-model="item.option_title"  type="text"/>
						</div>
					  </div>
					</el-form-item>	
				</div>
				<div v-if="form.question_type ==4">
					<el-form-item label="试题标题：" prop="question_title">
					  <el-input style="width: 720px;" v-model="form.question_title" placeholder="请输入" type="text"/>
					</el-form-item>
					<el-form-item label="所属课程：" prop="kecheng_id">
					  <el-select  style="width: 720px;" v-model="form.kecheng_id" placeholder="请选择">
						 <el-option
						   v-for="item in selist"
						   :key="item.id"
						   :label="item.kecheng_name"
						   :value="item.id">
						 </el-option>
					  </el-select>
					</el-form-item>	
					
					<el-form-item  label="试题答案：" prop="answer">
					  <el-input style="width: 720px;" v-model="form.answer" :rows="6" placeholder="请输入" type="textarea"/>
					</el-form-item>	
				</div>
				
			</el-form>
			<!-- <div class="yulan">
				<div class="yulan_title">问题预览：1、张三喝醉之后开车，在行驶过程中装上了闯红灯的行人，导致行人死亡，请问该起事故责任如何划分？</div>
				<div class="yulan_box">
					<div class="yulan_item">A 、张三全责</div>
					<div class="yulan_item">B 、行人全责</div>
					<div class="yulan_item">C、行人与张三各半责</div>
				</div>
			</div> -->
			<div  style="text-align: center;margin-top: 50px;">
				<el-button style="width: 112px;" @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submitFormying" v-if="form.question_type == 4">保存并提交</el-button>
				<el-button type="primary" @click="submitForm" v-else>保存并提交</el-button>
			</div>
			
		</div>
	</div>
</template>
<script>
import {kecheng_list,add_question,add_yingyong_question,question_details,edit_question,edit_yingyong_question} from "../../api/new.js";		
	export default {
		data() {
			return {
				jin:false,
				sel: [{ value: 1, label: '单选题' }, { value: 2, label: '多选题' },
					  { value: 3, label: '判断题' }, { value: 4, label: '应用题' }],
				open:false,
				loading: false,
				
				selist:[{value:'',label:'全部'},{value:1,label:'是'},{value:0,label:'否'}],
				panduanlist:[{ value: 1, label: '单选题' }, { value: 2, label: '多选题' }],
				form:{
					question_type:1,
					kecheng_id:'',
					question_title:'',
					option:[
						{"option_sn":"","option_title":"","is_yes":1},
						{"option_sn":"","option_title":"","is_yes":0}
					],
					answer:'',
				},
				rules:{},
				panduan:[
					{"option_sn":"","option_title":"","is_yes":1},
					{"option_sn":"","option_title":"","is_yes":0}]
			};
		},
		
		mounted() {
			this.getList()
			if(this.$route.query.id){
				this.form.kecheng_id = this.$route.query.id
				this.jin = true
				this.question_details()
			}
		},
		methods: {
			//列表
			getList(){
				var _this = this
				var data = {limit:1000,page:1}
				kecheng_list(data).then((res) => {
					if (res.code == 0) {
						this.selist = res.data
					} else {
						this.$message.error(res.msg);
					} 
				})
			},
			//详情
			question_details(){
				var _this = this
				var data = {id:this.form.kecheng_id}
				question_details(data).then((res) => {
					if (res.code == 0) {
						this.form = res.data
						this.panduan = this.form.option
					} else {
						this.$message.error(res.msg);
					} 
				})
			},
			//保存
			submitForm(){
				var _this = this
				
				this.form.option = JSON.stringify(this.panduan)
				if(this.$route.query.id){
					//修改
					edit_question(this.form).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							setTimeout(function(){
								_this.back()
							},1000)
						} else {
							this.$message.error(res.msg);
						}
					  }).catch((err) => {
							console.log(err);
					  });
				}else{
					//新增
					add_question(this.form).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							setTimeout(function(){
								_this.back()
							},1000)
						} else {
							this.$message.error(res.msg);
						}
					  }).catch((err) => {
							console.log(err);
					  });
				}
			},
			//应用题保存
			submitFormying(){
				var _this = this 
				if(this.$route.query.id){
					//修改
					var data = {
						id:this.form.id,
						question_title:this.form.question_title,
						kecheng_id:this.form.kecheng_id,
						question_type:this.form.question_type,
						answer:this.form.answer,
					}
					edit_yingyong_question(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							setTimeout(function(){
								_this.back()
							},1000)
						} else {
							this.$message.error(res.msg);
						}
					  }).catch((err) => {
							console.log(err);
					  });
				}else{
					//新增
					var data = {
						question_title:this.form.question_title,
						kecheng_id:this.form.kecheng_id,
						question_type:this.form.question_type,
						answer:this.form.answer,
					}
					add_yingyong_question(data).then((res) => {
						if (res.code == 0) {
							_this.$message.success(res.msg);
							setTimeout(function(){
								_this.back()
							},1000)
						} else {
							this.$message.error(res.msg);
						}
					  }).catch((err) => {
							console.log(err);
					  });
				}
			},
			cancel(){
				this.$router.go(-1);
			},
			back(){
				this.$router.go(-1);
			},
			//选择判断题的答案
			pandaunsel(index){
				this.panduan.forEach(function (item,index){
					item.is_yes = 0
				})
				this.panduan[index].is_yes = 1
			},
			//添加选项
			addti(){
				this.panduan.push({"option_sn":"","option_title":"","is_yes":0})
			},
			//删除选项
			del(index){
				this.panduan.splice(index,1)
			},
			// 多选答案
			duosel(index){
				// this.form.option.forEach(function (item,index){
				// 	if(item.is_yes == 1){
				// 		item.is_yes = 0
				// 	}else{
				// 		item.is_yes = 1
				// 	}
				// })
					
				if(this.panduan[index].is_yes == 1){
					this.panduan[index].is_yes = 0
				}else{
					this.panduan[index].is_yes = 1
				}
			},
			
		},
	};
</script>
<style lang="less" scoped>
div{
	box-sizing: border-box;
}
.content{
	width: 100%;
	min-width: 1000px;
	background: #FFFFFF;
	border-radius: 20px;
	padding: 30px;	
	.top{
		width: 100%;
		margin-top: 50px;
		.box{
			width: 720px;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			.box_item{
				width: 50%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 20px;
				.ckas{
					width: 28px;
					height: 28px;
					cursor: pointer;
				}
				.del{
					width: 28px;
					height: 28px;
					cursor: pointer;
				}
			}
		}
		.zujuan_btn{
			width: 140px;
			height: 44px;
			background: #ED7F26;
			border-radius: 10px;
			font-size: 16px;
			color: #FFFFFF;
			line-height: 44px;
			text-align: center;
			cursor: pointer;
			// margin-left: 35px;
			display: flex;
			align-items: center;
			justify-content: center;
			img{
				width: 24px;
				height: 24px;
				margin-right: 6px;
			}
		}
		.zujuan_btn:hover{
			opacity: 0.7;
		}
		.zujuan_btn:active{
			opacity: 0.9;
		}
		.yulan{
			width: 100%;
			padding-left: 100px;
			.yulan_title{
				font-size: 16px;
				color: #333333;
				line-height: 32px;
			}
			.yulan_box{
				width: 100%;
				display: flex;
				flex-wrap: wrap;
				.yulan_item{
					font-size: 16px;
					color: #333333;
					line-height: 32px;
					margin-right: 50px;
				}
			}
		}
	
	}
	
}	
</style>



// WEBPACK FOOTER //
// src/components/tiku/addtiku.vue